import { render, staticRenderFns } from "./CountdownOffer.vue?vue&type=template&id=2f4fdb18"
import script from "./CountdownOffer.vue?vue&type=script&lang=ts"
export * from "./CountdownOffer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports